// extracted by mini-css-extract-plugin
module.exports = {"highlight":"offer-module--highlight--2aJA_"};